var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "bg-light py-4" }, [
    _c("div", { staticClass: "row pb-3" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "router-link",
            { staticClass: "text-primary-link", attrs: { to: "/rewards" } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.rewards.title")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: { to: "/user-rewards" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.rewards.my_redeemed_rewards")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(" " + _vm._s(_vm.$t("message.rewards.detail")) + "\n    ")
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.userReward
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
            _c("div", { staticClass: "card" }, [
              _c("img", {
                staticClass: "card-img-top",
                attrs: {
                  src: _vm.userReward.reward.image_url,
                  alt: _vm.userReward.reward.name_th
                }
              }),
              _vm._v(" "),
              _vm.userReward.is_used
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-3 pt-3 text-info d-flex justify-content-center align-items-center"
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.rewards.used_on")) +
                              ": " +
                              _vm._s(
                                _vm._f("prettyDate")(_vm.userReward.used_at)
                              )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge text-badge-small badge-pill py-1 px-2",
                      class: _vm.getUserRewardStatus(_vm.userReward).cssClass
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getUserRewardStatus(_vm.userReward).text) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pt-3" }, [
                  _c("h3", { staticClass: "mb-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$i18n.locale === "th"
                          ? _vm.userReward.reward.title_th
                          : _vm.userReward.reward.title_en
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.userReward.promo_code
                  ? _c("div", { staticClass: "pt-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.promo_code.code")) +
                          ": " +
                          _vm._s(_vm.userReward.promo_code.code) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.expire_date
                  ? _c("div", { staticClass: "pt-2 text-secondary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.promo_code.expiring")) +
                          ": " +
                          _vm._s(
                            _vm._f("prettyOnlyDate")(_vm.userReward.expire_date)
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.redeemed_at
                  ? _c("div", { staticClass: "pt-3 text-secondary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.rewards.redeemed_on")) +
                          ": " +
                          _vm._s(
                            _vm._f("prettyDate")(_vm.userReward.redeemed_at)
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.wogi_order_status ||
                _vm.userReward.reward.type === "voucher"
                  ? _c("div", { staticClass: "pt-4" }, [
                      _vm.userReward.wogi_order_status === "pending"
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fal fa-stopwatch text-info"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "message.rewards.processing_voucher_remark"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm.userReward.wogi_order_status === "failed"
                        ? _c("span", [
                            _c("i", {
                              staticClass:
                                "fal fa-exclamation-triangle text-danger"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("message.rewards.redeem_voucher_error")
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userReward.wogi_order_status === "pending"
                        ? _c("div", { staticClass: "pt-3" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-block",
                                on: {
                                  click: function($event) {
                                    return _vm.fetchUserRewardDetail(_vm.id)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("message.button.refresh")))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userReward.wogi_order_status === "successful" ||
                      _vm.userReward.reward.type === "voucher"
                        ? _c("div", { staticClass: "pt-3" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-block",
                                attrs: { disabled: _vm.isLoading },
                                on: {
                                  click: function($event) {
                                    return _vm.checkUsedReward()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.isLoading
                                        ? _vm.$t("message.button.loading")
                                        : _vm.$t("message.rewards.use_reward")
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.promo_code &&
                !_vm.userReward.promo_code_usage &&
                !_vm.userReward.is_expired
                  ? _c(
                      "div",
                      { staticClass: "pt-4" },
                      [
                        _c("div", { staticClass: "text-remark pb-3" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.rewards.promo_code_remark")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-info btn-block",
                            attrs: { to: "/booking/start" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.book_a_service"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.delivery_info
                  ? _c("div", [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-2" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("message.rewards.delivery_info"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.userReward.reward.delivery_info_type === "email_tel"
                        ? _c("div", [
                            _c("ul", { staticClass: "list-unstyled mb-0" }, [
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.rewards.contact_name")
                                  ) +
                                    ": " +
                                    _vm._s(_vm.userReward.delivery_info.tel)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.rewards.contact_email")
                                  ) +
                                    ": " +
                                    _vm._s(_vm.userReward.delivery_info.email)
                                )
                              ])
                            ])
                          ])
                        : _c("div", [
                            _c("ul", { staticClass: "list-unstyled mb-0" }, [
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.rewards.contact_name")
                                  ) +
                                    ": " +
                                    _vm._s(_vm.userReward.delivery_info.name)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.rewards.contact_tel")
                                  ) +
                                    ": " +
                                    _vm._s(_vm.userReward.delivery_info.tel)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm.userReward.delivery_info.village
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.userReward.delivery_info.village
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.room_no
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.shipping_address.room_no"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.userReward.delivery_info.room_no
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.house_no
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.shipping_address.house_no"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.userReward.delivery_info
                                              .house_no
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.village_no
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.shipping_address.village_no"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.userReward.delivery_info
                                              .village_no
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.soi
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.shipping_address.soi"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.userReward.delivery_info.soi
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("message.shipping_address.road")
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.userReward.delivery_info.road
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.sub_district
                                  ? _c("span", [
                                      _vm.$i18n.locale === "th"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.shipping_address.sub_district"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              _vm.userReward.delivery_info
                                                .sub_district
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.district
                                  ? _c("span", [
                                      _vm.$i18n.locale === "th"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.userReward.delivery_info
                                                  .address_province_id != 1
                                                  ? "อ."
                                                  : ""
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("multiLangName")(
                                            _vm.userReward.delivery_info
                                              .district
                                          )
                                        ) + "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userReward.delivery_info.address_province
                                  ? _c("span", [
                                      _vm.$i18n.locale === "th"
                                        ? _c("span", [_vm._v("จ.")])
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("multiLangName")(
                                            _vm.userReward.delivery_info
                                              .address_province
                                          )
                                        ) + "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.userReward.delivery_info.zip_code
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                    ])
                  : _vm.userReward.reward.delivery_info_type &&
                    !_vm.userReward.delivery_info
                  ? _c(
                      "div",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            attrs: {
                              to:
                                "/user-rewards/" +
                                _vm.userReward.id +
                                "/delivery-info"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("message.rewards.add_delivery_info")
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userReward.delivery_info && _vm.userReward.sent_at
                  ? _c("div", { staticClass: "mt-3 text-secondary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.rewards.sent_on")) +
                          ": " +
                          _vm._s(_vm._f("prettyDate")(_vm.userReward.sent_at)) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      : _c("div", [_c("loader")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fas fa-check-circle fa-lg" })])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2923d92a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2923d92a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/UserRewardDetail.vue
// module id = 2308
// module chunks = 0